import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { AiOutlineSearch } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import axioPath from '../../../../../api/axioPath';
import Spinner from '../../../../components/Spinner'
import { shippedFailedOrderList, deliveredFailedOrderList } from '../../../../../redux/actions/admin';
import { SearchWrapper, SelectWrapper } from '../DashBoard/dashBoardStyled'
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'

import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import CsvDownloader from 'react-csv-downloader';

import Typography from '@material-ui/core/Typography';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import HOCButton from 'web/components/Button';

import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';
import styles from './retryOrders.module.scss'
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import DatePicker from 'web/components/DatePicker';
import moment from 'moment';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const buttonStyle = { background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }

function FailedOrders() {
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const dispatch = useDispatch();
    let history = useHistory()
    let location = useLocation();
    const [loader, setLoader] = useState(false)
    const [value, setValue] = useState(0);
    const [modal, setModal] = useState(false);
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [modalMessage, setModalMessaage] = useState('')
    const [shippedOrderDataList, setshippedOrderDataList] = useState([])
    const [shippedOrderFinalData, setshippedOrderFinalData] = useState([])
    const [deliveredOrderDataList, setdeliveredOrderDataList] = useState([])
    const [deliveredOrderFinalData, setdeliveredOrderFinalData] = useState([])
    const [shippedCsvData, setShippedCsvData] = useState([])
    const [deliveredCsvData, setDeliveredCsvData] = useState([])
    const [tableSearch, setTableSearch] = useState('')
    const [searchShippedOrderDataList, setsearchShippedOrderDataList] = useState([]);
    const [searchDeliveredOrderDataList, setsearchDeliveredOrderDataList] = useState([]);
    const [shippedPage, setshippedPage] = useState(1);
    const [shippedPageCount, setshippedPageCount] = useState(0);
    const [deliveredPage, setdeliveredPage] = useState(1);
    const [deliveredPageCount, setdeliveredPageCount] = useState(0);

    let toDateRetryOrders = new Date();
    let fromDateRetryOrders = new Date();
    fromDateRetryOrders.setMonth(fromDateRetryOrders.getMonth() - 1)
    toDateRetryOrders.setMonth(toDateRetryOrders.getMonth() + 1)
    const [startDateValue, setStartDateValue] = useState(moment(fromDateRetryOrders).format("MM/DD/YYYY"))
    const [endDateValue, setEndDateValue] = useState(moment(toDateRetryOrders).format("MM/DD/YYYY"))

    const [userFilterState, setUserFilterState] = useState({
        fromDate: moment(fromDateRetryOrders).format("YYYY-MM-DD"),
        toDate: moment(toDateRetryOrders).format("YYYY-MM-DD"),
    });

    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        fetchShippedFailedAPI();
        fetchDeliveryFailedAPI();
    }, []);

    //change tab index
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        //set date default
        let toDateRetryOrders = new Date();
        let fromDateRetryOrders = new Date();
        fromDateRetryOrders.setMonth(fromDateRetryOrders.getMonth() - 1)
        toDateRetryOrders.setMonth(toDateRetryOrders.getMonth() + 1)
        setUserFilterState(prevState => ({
            ...prevState,
            ["fromDate"]: moment(fromDateRetryOrders).format("YYYY-MM-DD"),
            ["toDate"]: moment(toDateRetryOrders).format("YYYY-MM-DD"),
        }))
        setStartDateValue(moment(fromDateRetryOrders).format("MM/DD/YYYY"))
        setEndDateValue(moment(toDateRetryOrders).format("MM/DD/YYYY"))
    };

    const fetchShippedFailedAPI = async () => {
        let response = '';
        if (!userFilterState.toDate || !userFilterState.fromDate) {
            setModalMessaage("Please enter the correct Date Range.");
            setModal(!modal)
            return
        }

        response = await dispatch(shippedFailedOrderList(userFilterState.fromDate, userFilterState.toDate));
        if (response && response.status === 'SUCCESS') {
            if (response.payload && response.payload.orders && response.payload.orders.content) {
                let adminPostList = response.payload.orders.content
                setshippedOrderDataList(adminPostList)
                setsearchShippedOrderDataList(adminPostList)

                //set csv data
                setShippedCSVDate(adminPostList)

                let pageData = JSON.parse(JSON.stringify(adminPostList))
                setshippedOrderFinalData(pageData.splice(shippedPage * 10 - 10, 10))
                if (adminPostList.length % 10 === 0) {
                    setshippedPageCount(adminPostList.length / 10)
                } else {
                    setshippedPageCount(Math.trunc(adminPostList.length / 10) + 1)
                }
                setTableSearch('')
            }
        } else {
            if (response.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalMessaage(response.message)
                setModal(!modal)
            }
        }
    };

    const fetchDeliveryFailedAPI = async () => {
        let response = '';
        if (!userFilterState.toDate || !userFilterState.fromDate) {
            setModalMessaage("Please enter the correct Date Range.");
            setModal(!modal)
            return
        }
        setLoader(true)
        response = await dispatch(deliveredFailedOrderList(userFilterState.fromDate, userFilterState.toDate));
        setLoader(false)
        if (response && response.status === 'SUCCESS') {
            if (response.payload && response.payload.orders && response.payload.orders.content) {
                let adminPostList = response.payload.orders.content
                setdeliveredOrderDataList(adminPostList)
                setsearchDeliveredOrderDataList(adminPostList)

                //set csv data
                setDeliveredCSVDate(adminPostList)

                let pageData = JSON.parse(JSON.stringify(adminPostList))
                setdeliveredOrderFinalData(pageData.splice(deliveredPage * 10 - 10, 10))
                if (adminPostList.length % 10 === 0) {
                    setdeliveredPageCount(adminPostList.length / 10)
                } else {
                    setdeliveredPageCount(Math.trunc(adminPostList.length / 10) + 1)
                }
                setTableSearch('')
            }
        } else {
            if (response.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalMessaage(response.message)
                setModal(!modal)
            }
        }
    };

    //handle page change in shipped section
    const handleShippedPageChange = (event, value) => {
        setshippedPage(value);
        let dataListtemp = JSON.parse(JSON.stringify(searchShippedOrderDataList))
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setshippedOrderFinalData(pageData.splice(value * 10 - 10, 10))
    };

    //handle page change in delivered section
    const handleDeliveredPageChange = (event, value) => {
        setdeliveredPage(value);
        let dataListtemp = JSON.parse(JSON.stringify(searchDeliveredOrderDataList))
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setdeliveredOrderFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const handleToggle = () => {
        setModal(!modal);
    }

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value

        //post needs
        let dataNeedsListtemp = shippedOrderDataList.filter(value => {
            return (
                (value.id?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo?.companyName?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo?.address?.city?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (stateConvert(value.buyerInfo?.address?.state)?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo?.address?.zip?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.sellerInfo?.companyName?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.sellerInfo?.address?.city?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (stateConvert(value.sellerInfo?.address?.state)?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.sellerInfo?.address?.zip?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderDetails?.material?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderDetails?.commodity?.commodityName?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderDetails?.quantity?.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setshippedPage(1)
        if (dataNeedsListtemp.length % 10 === 0) {
            setshippedPageCount(dataNeedsListtemp.length / 10)
        } else {
            setshippedPageCount(Math.trunc(dataNeedsListtemp.length / 10) + 1)
        }

        let tempSearchData = JSON.parse(JSON.stringify(dataNeedsListtemp))
        setsearchShippedOrderDataList(tempSearchData)
        setShippedCSVDate(tempSearchData)
        setshippedOrderFinalData(dataNeedsListtemp.splice(0, 10))

        //post Inventory
        let dataInventoryListtemp = deliveredOrderDataList.filter(value => {
            return (
                (value.id?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo?.companyName?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo?.address?.city?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (stateConvert(value.buyerInfo?.address?.state)?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo?.address?.zip?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.sellerInfo?.companyName?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (stateConvert(value.sellerInfo?.address?.state)?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.sellerInfo?.address?.zip?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderDetails?.material?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderDetails?.commodity?.commodityName?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderDetails?.quantity?.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setdeliveredPage(1)
        if (dataInventoryListtemp.length % 10 === 0) {
            setdeliveredPageCount(dataInventoryListtemp.length / 10)
        } else {
            setdeliveredPageCount(Math.trunc(dataInventoryListtemp.length / 10) + 1)
        }

        let tempSearchDataDel = JSON.parse(JSON.stringify(dataInventoryListtemp))
        setsearchDeliveredOrderDataList(tempSearchDataDel)
        setDeliveredCSVDate(tempSearchDataDel)
        setdeliveredOrderFinalData(dataInventoryListtemp.splice(0, 10))
    }

    let shippedHeaderArr = [
        { title: 'Order ID', },
        { title: 'Buyer Company Name', },
        { title: 'Buyer City', },
        { title: 'Buyer State', },
        { title: 'Buyer Zip', },
        { title: 'Buyer Broker', },
        { title: 'Buyer FC Member', },
        { title: 'Seller Company Name', },
        { title: 'Seller City', },
        { title: 'Seller State', },
        { title: 'Seller Zip', },
        { title: 'Seller Broker', },
        { title: 'Seller FC Member', },
        { title: 'Material', },
        { title: 'Commodity', },
        { title: 'Order Quantity', },
        { title: 'Actions', }
    ];

    let deliveredHeaderArr = [
        { title: 'Order ID', },
        { title: 'Buyer Company Name', },
        { title: 'Buyer City', },
        { title: 'Buyer State', },
        { title: 'Buyer Zip', },
        { title: 'Buyer Broker', },
        { title: 'Buyer FC Member', },
        { title: 'Seller Company Name', },
        { title: 'Seller City', },
        { title: 'Seller State', },
        { title: 'Seller Zip', },
        { title: 'Seller Broker', },
        { title: 'Seller FC Member', },
        { title: 'Material', },
        { title: 'Commodity', },
        { title: 'Order Quantity', },
        { title: 'Actions', }
    ];

    let shippedColumns = [
        { id: 'OrderID', displayName: 'Order ID' },
        { id: 'BuyerCompanyName', displayName: 'Buyer Company Name' },
        { id: 'BuyerCity', displayName: 'Buyer City' },
        { id: 'BuyerState', displayName: 'Buyer State' },
        { id: 'BuyerZip', displayName: 'Buyer Zip' },
        { id: 'BuyerBroker', displayName: 'Buyer Broker' },
        { id: 'BuyerFCMember', displayName: 'Buyer FC Member' },
        { id: 'SellerCompanyName', displayName: 'Seller Company Name' },
        { id: 'SellerCity', displayName: 'Seller City' },
        { id: 'SellerState', displayName: 'Seller State' },
        { id: 'SellerZip', displayName: 'Seller Zip' },
        { id: 'SellerBroker', displayName: 'Seller Broker' },
        { id: 'SellerFCMember', displayName: 'Seller FC Member' },
        { id: 'Material', displayName: 'Material' },
        { id: 'Commodity', displayName: 'Commodity' },
        { id: 'OrderQuantity', displayName: 'Order Quantity' },
    ];

    let deliveredColumns = [
        { id: 'OrderID', displayName: 'Order ID' },
        { id: 'BuyerCompanyName', displayName: 'Buyer Company Name' },
        { id: 'BuyerCity', displayName: 'Buyer City' },
        { id: 'BuyerState', displayName: 'Buyer State' },
        { id: 'BuyerZip', displayName: 'Buyer Zip' },
        { id: 'BuyerBroker', displayName: 'Buyer Broker' },
        { id: 'BuyerFCMember', displayName: 'Buyer FC Member' },
        { id: 'SellerCompanyName', displayName: 'Seller Company Name' },
        { id: 'SellerCity', displayName: 'Seller City' },
        { id: 'SellerState', displayName: 'Seller State' },
        { id: 'SellerZip', displayName: 'Seller Zip' },
        { id: 'SellerBroker', displayName: 'Seller Broker' },
        { id: 'SellerFCMember', displayName: 'Seller FC Member' },
        { id: 'Material', displayName: 'Material' },
        { id: 'Commodity', displayName: 'Commodity' },
        { id: 'OrderQuantity', displayName: 'Order Quantity' },
    ];

    const setShippedCSVDate = (resultData) => {
        let tempCsvData = resultData.map(items => {
            return ({
                OrderID: items.id,
                BuyerCompanyName: items.buyerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                BuyerCity: items.buyerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ").trim(),
                BuyerState: stateConvert(items.buyerInfo?.address?.state),
                BuyerZip: items.buyerInfo?.address?.zip,
                BuyerBroker: items.buyerIsReseller ? 'Yes' : 'No',
                BuyerFCMember: items.buyerInnerCircle ? 'Yes' : 'No',
                SellerCompanyName: items.sellerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                SellerCity: items.sellerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")?.trim(),
                SellerState: stateConvert(items.sellerInfo?.address?.state),
                SellerZip: items.sellerInfo?.address?.zip,
                SellerBroker: items.sellerIsReseller ? 'Yes' : 'No',
                SellerFCMember: items.sellerInnerCircle ? 'Yes' : 'No',
                Material: items.orderDetails?.material,
                Commodity: items.orderDetails?.commodity?.commodityName ? items.orderDetails.commodity.commodityName : 'NA',
                OrderQuantity: items.orderDetails?.quantity,
            })
        })
        setShippedCsvData(tempCsvData)
    }

    const setDeliveredCSVDate = (resultData) => {
        let tempCsvData = resultData.map(items => {
            return ({
                OrderID: items.id,
                BuyerCompanyName: items.buyerInfo?.companyName,
                BuyerCity: items.buyerInfo?.address?.city?.trim(),
                BuyerState: stateConvert(items.buyerInfo?.address?.state),
                BuyerZip: items.buyerInfo?.address?.zip,
                BuyerBroker: items.buyerIsReseller ? 'Yes' : 'No',
                BuyerFCMember: items.buyerInnerCircle ? 'Yes' : 'No',
                SellerCompanyName: items.sellerInfo?.companyName,
                SellerCity: items.sellerInfo?.address?.city?.trim(),
                SellerState: stateConvert(items.sellerInfo?.address?.state),
                SellerZip: items.sellerInfo?.address?.zip,
                SellerBroker: items.sellerIsReseller ? 'Yes' : 'No',
                SellerFCMember: items.sellerInnerCircle ? 'Yes' : 'No',
                Material: items.orderDetails?.material,
                Commodity: items.orderDetails?.commodity?.commodityName ? items.orderDetails.commodity.commodityName : 'NA',
                OrderQuantity: items.orderDetails?.quantity,
            })
        })
        setDeliveredCsvData(tempCsvData)
    }

    const retryOrder = (id, type) => {
        const token = localStorage.getItem("token")
        let url = ''
        if (type === 'NotDelivered') url = `order/admin/shipped/payment?orderId=${id}`
        else url = `order/admin/deliverd/payment?orderId=${id}`
        axioPath.post(url, {}, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            fetchShippedFailedAPI();
            fetchDeliveryFailedAPI();
            setModalMessaage(response.data.message)
            setModal(!modal)
        }).catch((ex) => {
            if (ex.response?.status === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            } else {
                setModalMessaage(ex.message)
                setModal(!modal)
            }
        });
    }

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('RETRY_ORDER'))) ?

                <Container>
                    <TableWrapper>
                        {(loaderVisible || loader) && <Spinner />}
                        <div class="column">
                            <Heading>
                                <h3>ORDERS ON HOLD</h3>
                                <div className='d-flex flex-wrap flex-sm-nowrap'>
                                    <SearchWrapper>
                                        <input type="text" placeholder='Search' value={tableSearch}
                                            onChange={handleSearchChange} />
                                        <AiOutlineSearch />
                                    </SearchWrapper>
                                    <CsvDownloader
                                        filename={value === 0 ? 'Undelivered Order Report' : 'Delivered Order Report'}
                                        columns={value === 0 ? shippedColumns : deliveredColumns}
                                        datas={value === 0 ? shippedCsvData : deliveredCsvData}>
                                        <button
                                            style={buttonStyle}>
                                            Export
                                        </button>
                                    </CsvDownloader>

                                </div>
                            </Heading>
                            <InnerHeader>
                                <DateWrapper>
                                    <label>From</label>
                                    <DatePicker
                                        name="fromDateRetryOrders"
                                        placeholderText=""
                                        maxDOBirth={userFilterState.toDate}
                                        value={userFilterState.fromDate}
                                        inputValue={startDateValue}
                                        callBackFun={(date, value) => {
                                            setStartDateValue(value)
                                            if (moment(date, moment.ISO_8601, true).isValid()) {
                                                setUserFilterState((prevState) => ({
                                                    ...prevState,
                                                    ["fromDate"]: moment(date).format("YYYY-MM-DD"),
                                                }));
                                            } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                                                setUserFilterState((prevState) => ({
                                                    ...prevState,
                                                    ["fromDate"]: null,
                                                }));
                                            }
                                        }}
                                    />
                                </DateWrapper>
                                <DateWrapper>
                                    <label>To</label>
                                    <DatePicker
                                        name="toDateRetryOrders"
                                        placeholderText=""
                                        minDOBirth={userFilterState.fromDate}
                                        value={userFilterState.toDate}
                                        inputValue={endDateValue}
                                        callBackFun={(date, value) => {
                                            setEndDateValue(value)
                                            if (moment(date, moment.ISO_8601, true).isValid()) {
                                                setUserFilterState((prevState) => ({
                                                    ...prevState,
                                                    ["toDate"]: moment(date).format("YYYY-MM-DD"),
                                                }));
                                            } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                                                setUserFilterState((prevState) => ({
                                                    ...prevState,
                                                    ["toDate"]: null,
                                                }));
                                            }
                                        }}
                                    />
                                </DateWrapper>
                                <button
                                    className='submit-btn'
                                    onClick={() => {
                                        fetchShippedFailedAPI();
                                        fetchDeliveryFailedAPI();
                                    }}
                                >
                                    Submit
                                </button>
                            </InnerHeader>
                        </div>

                        <AppBar position="static">
                            <Tabs value={value} onChange={handleChangeTab} aria-label="simple tabs example">
                                <Tab label="Undelivered Orders" {...a11yProps(0)} />
                                <Tab label="Delivered Orders" {...a11yProps(1)} />
                            </Tabs>
                        </AppBar>

                        <TabPanel value={value} index={0}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        {shippedHeaderArr.map((items, index) => (
                                            <th key={index}>{items.title}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        shippedOrderFinalData.map((items, index) => (
                                            <tr className={styles.homeWrapper} key={index}>
                                                <td>{items.id}</td>
                                                <td>{items.buyerInfo?.companyName}</td>
                                                <td>{items.buyerInfo?.address?.city?.trim()}</td>
                                                <td>{stateConvert(items.buyerInfo?.address?.state)}</td>
                                                <td>{items.buyerInfo?.address?.zip}</td>
                                                <td>{items.buyerIsReseller ? 'Yes' : 'No'}</td>
                                                <td>{items.buyerInnerCircle ? 'Yes' : 'No'}</td>
                                                <td>{items.sellerInfo && items.sellerInfo.companyName}</td>
                                                <td>{items.sellerInfo?.address?.city?.trim()}</td>
                                                <td>{stateConvert(items.sellerInfo?.address?.state)}</td>
                                                <td>{items.sellerInfo?.address?.zip}</td>
                                                <td>{items.sellerIsReseller ? 'Yes' : 'No'}</td>
                                                <td>{items.sellerInnerCircle ? 'Yes' : 'No'}</td>
                                                <td>{items.orderDetails && items.orderDetails.material}</td>
                                                <td>{items.orderDetails && items.orderDetails.commodity && items.orderDetails.commodity.commodityName ? items.orderDetails.commodity.commodityName : 'NA'}</td>
                                                <td>{items.orderDetails.quantity}</td>
                                                <td>
                                                    <HOCButton
                                                        type='app-green-button submitBtn'
                                                        handleClick={() => retryOrder(items.id, 'NotDelivered')}
                                                    >
                                                        Lock Payment
                                                    </HOCButton>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                            {shippedOrderFinalData.length !== 0 && <Pagination count={shippedPageCount}
                                page={shippedPage}
                                onChange={handleShippedPageChange} />}
                        </TabPanel>

                        <TabPanel value={value} index={1}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        {deliveredHeaderArr.map((items, index) => (
                                            <th key={index}>{items.title}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        deliveredOrderFinalData.map((items, index) => (
                                            <tr className={styles.homeWrapper} key={index}>
                                                <td>{items.id}</td>
                                                <td>{items.buyerInfo?.companyName}</td>
                                                <td>{items.buyerInfo?.address?.city?.trim()}</td>
                                                <td>{stateConvert(items.buyerInfo?.address?.state)}</td>
                                                <td>{items.buyerInfo?.address?.zip}</td>
                                                <td>{items.buyerIsReseller ? 'Yes' : 'No'}</td>
                                                <td>{items.buyerInnerCircle ? 'Yes' : 'No'}</td>
                                                <td>{items.sellerInfo && items.sellerInfo.companyName}</td>
                                                <td>{items.sellerInfo?.address?.city?.trim()}</td>
                                                <td>{stateConvert(items.sellerInfo?.address?.state)}</td>
                                                <td>{items.sellerInfo?.address?.zip}</td>
                                                <td>{items.sellerIsReseller ? 'Yes' : 'No'}</td>
                                                <td>{items.sellerInnerCircle ? 'Yes' : 'No'}</td>
                                                <td>{items.orderDetails && items.orderDetails.material}</td>
                                                <td>{items.orderDetails && items.orderDetails.commodity && items.orderDetails.commodity.commodityName ? items.orderDetails.commodity.commodityName : 'NA'}</td>
                                                <td>{items.orderDetails.quantity}</td>
                                                <td>
                                                    <HOCButton
                                                        type='app-green-button submitBtn'
                                                        handleClick={() => retryOrder(items.id, 'Delivered')}
                                                    >
                                                        Process Payment
                                                    </HOCButton>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                            {deliveredOrderFinalData.length !== 0 && <Pagination count={deliveredPageCount}
                                page={deliveredPage}
                                onChange={handleDeliveredPageChange} />}
                        </TabPanel>
                    </TableWrapper>

                    <Modal isOpen={modal} centered={true}>
                        <ModalHeader toggle={handleToggle}><h6>Status</h6></ModalHeader>
                        <ModalBody>
                            {modalMessage}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleToggle}>OK</Button>
                        </ModalFooter>
                    </Modal>
                </Container >

                :
                <p>You are not authorized to view this page.</p>
            }
        </>

    )
};

export default FailedOrders;

const Container = styled.div`
  
  /* .MuiTabs-flexContainer {
                    border-bottom: 4px solid #e8e8e8;
} */
`

const InnerHeader = styled.div`
    min-height: 50px;
    display: flex;
    padding: 0 20px;
    align-items: flex-end;
    border-bottom: solid 1px #97979729;
    padding: 0 20px;
    gap: 10px;
    padding-bottom: 15px;
    flex-wrap: wrap;
    margin-top:1rem;
    button.submit-btn{
        background: #61b01f; 
        background: linear-gradient(to bottom, #61b01f 0%,#27911b 100%);
        color: white; 
        white-space: nowrap; 
        border: 0; 
        border-radius: 5px; 
        padding: 5px 15px; 
        cursor: pointer;
        height: 42px;
        margin-bottom: 6px;
    }
`
const DateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 5px 13px;
    border-radius: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 130px;
    max-width: 150px;
    max-height: 42px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  label {
    padding: 8px 8px 8px 0px;
    font-size: 16px;
    @media (max-width: 465px){
        min-width: 60px;
    }
  }
`;